import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pautas',
  templateUrl: './pautas.component.html',
  styleUrls: ['./pautas.component.css']
})
export class PautasComponent implements OnInit {

  constructor() { }

  ngOnInit() { }

  Mudarestado(el) {
    var display = document.getElementById(el).style.display;
    if (display == "none") {
      document.getElementById(el).style.display = 'block';
    }
    else
      document.getElementById(el).style.display = 'none';
  }

}



// WEBPACK FOOTER //
// ./src/app/portal-cmcti/pautas/pautas.component.ts